import { apiClient } from '@v2/lib';
import type { App } from '@v2/types';

export const appsService = {
  /** GET /api/Apps — list all apps */
  getApps: async (): Promise<App[]> => {
    const response = await apiClient().get<App[]>('Apps');
    return Array.isArray(response.data) ? response.data : [];
  },
};
